const Commons = {
    install: (Vue, options) => {

        const setHeight = function () {
            if (!document.body.classList.contains('modal-open'))
                setTimeout(() => {
                    window.parent.postMessage(
                        {
                            func: "setGioielleriaItalianaHeight",
                            message: document.body.scrollHeight,
                        },
                        "*"
                    );
                }, 1000);
        }

        const isAccessory = function (productType) {
            return (
                productType === "EXHIBITORS" ||
                productType === "WARRANTY" ||
                productType === "PACKAGING" ||
                productType === "KIT"
            );
        }

        const addToBasket = function (item) {
            window.parent.postMessage(
                {
                    func: "addToGioielleriaItalianaBasket",
                    message: item,
                },
                "*"
            );
        }

        const getBasket = function (item) {
            window.parent.postMessage(
                {
                    func: "getGioielleriaItalianaBasket",
                },
                "*"
            );
        }

        const formatShipmentDate = function (date) {
            const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
            if (regex.test(date))
                return date;
            let dd = String(new Date(date).getDate()).padStart(2, '0');
            let mm = String(new Date(date).getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = new Date(date).getFullYear();
            return dd + '/' + mm + '/' + yyyy;
        }

        const formatPrice = function (price) {
            return price > 0 ? price.toLocaleString("it-it", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""
        }

        Vue.setHeight = setHeight;
        Vue.isAccessory = isAccessory;
        Vue.addToBasket = addToBasket;
        Vue.formatShipmentDate = formatShipmentDate;
        Vue.formatPrice = formatPrice;
        Vue.getBasket = getBasket;
    }
}

export default Commons;